import React, { useCallback } from "react";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import ArrowUpOnSquareIcon from "@heroicons/react/24/solid/ArrowUpOnSquareIcon";
import { Button, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import EntityListPage from "../../common/crud/EntityListPage";
import { ClientTable } from "../../components/Clients/ClientTable";
import { ClientSearch } from "../../components/Clients/ClientSearch";
import useClients from "../../hooks/store/clients";
import { generateCSVClient } from "../../api/clients";
import { handleDownloadFile } from "../../utils";
import usePermissions from "../../hooks/usePermissions";

const Page = () => {
  const {
    Data,
    noOfRecords,
    rowsPerPage,
    page,
    loading,
    setPageNumberAction,
    setRowsPerPageAction,
  } = useClients();
  const { clientId, isClient } = usePermissions();
  const [downloadLoading, setDownloadLoading] = React.useState(false);
  const colorSet = useSelector((state) => state.color);
  const isScopedClient = isClient && Boolean(clientId);

  const handlePageChange = useCallback(
    (_, value) => {
      setPageNumberAction(value);
    },
    [setPageNumberAction]
  );

  const handleRowsPerPageChange = useCallback(
    (event) => {
      setRowsPerPageAction(event.target.value);
      setPageNumberAction(0);
    },
    [setPageNumberAction, setRowsPerPageAction]
  );

  const handleExport = useCallback(async () => {
    try {
      setDownloadLoading(true);
      const res = await generateCSVClient();
      const { data } = res;

      if (data) {
        handleDownloadFile(data, `Clients_${new Date().getTime()}.xlsx`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoading(false);
    }
  }, []);

  return (
    <EntityListPage
      headerAction={
        !isScopedClient ? (
          <Button
            component={Link}
            startIcon={
              <SvgIcon fontSize="small">
                <PlusIcon />
              </SvgIcon>
            }
            sx={{
              backgroundColor: colorSet.color,
              ":hover": { backgroundColor: colorSet.color },
              color: "white",
            }}
            to="/clients/add"
            variant="contained"
          >
            Add
          </Button>
        ) : null
      }
      loading={loading || downloadLoading}
      mountedSearch={isScopedClient ? <ClientSearch /> : null}
      search={!isScopedClient ? <ClientSearch /> : null}
      table={
        <ClientTable
          count={noOfRecords}
          items={Data}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
        />
      }
      title="Clients"
      toolbar={
        <Button
          color="inherit"
          startIcon={
            <SvgIcon fontSize="small">
              <ArrowUpOnSquareIcon />
            </SvgIcon>
          }
          onClick={handleExport}
        >
          Export
        </Button>
      }
    />
  );
};

export default Page;
